<template>
  <!-- Formulario de adicion de nodos -->
  <div id="formulario-nodos" style="width: 100%">
  <circle-loader ref="circleLoader" />

    <div v-if="!submitted">
      <!-- INIT FORMULARIO DE ADICION -->
      <b-form @submit="saveDevice" @reset="resetForm">
        <div class="groupBox">
          <!-- Fila 1 -->
          <b-row>
            <b-col>
              <form-input
                v-model="device.alias"
                label="Alias del dispositivo"
                v-bind:required="true"
              />
            </b-col>
            <!--spacer -->
            <b-col class="col-sm-1 col-xs-3" />
            <!--spacer -->
            <b-col>
              <form-input
                v-model="device.uuid"
                label="UUID del nodo (Hexadecimal)"
                v-bind:required="true"
              />
            </b-col>
          </b-row>

          <!-- Fila 2 -->
          <b-row>
            <b-col>
              <b-row>
                <b-col>
                  <form-input
                    v-model="device.location.province"
                    label="Provincia"
                    v-bind:required="true"
                  />
                </b-col>
                <b-col>
                  <form-input
                    type="text"
                    @keydown.native="zipCodeKeyDown($event)"
                    v-model="device.location.zip"
                    label="Código Postal"
                    v-bind:required="true"
                  />
                </b-col>
              </b-row>
            </b-col>
            <!--spacer -->
            <b-col class="col-sm-1 col-xs-3" />
            <!--spacer -->
            <b-col>
              <b-form-group
                label-size="sm"
                label="Asociar a ubicación"
                label-for="location_ref"
              >
                <b-form-select
                  size="sm"
                  id="location_ref"
                  name="location_ref"
                  v-model="selectedLocation"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="null"
                    >Ninguna ubicación</b-form-select-option
                  >

                  <b-form-select-option
                    v-for="(locationItem, index) in locationList"
                    v-bind:key="index"
                    v-bind:value="locationItem"
                  >
                    {{ locationItem }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Fila 3 -->
          <b-row>
            <b-col>
              <b-row>
                <b-col>
                  <b-form-group
                    label-size="sm"
                    label="Latitud**"
                    label-for="Latitud"
                  >
                    <b-form-input
                      size="sm"
                      id="Latitud"
                      name="Latitud"
                      placeholder="..."
                      @keydown.native="coordinatesKeyDown($event)"
                      v-model="device.location.latitude"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    label-size="sm"
                    label="Longitud**"
                    label-for="Longitud"
                  >
                    <b-form-input
                      size="sm"
                      id="Longitud"
                      name="Longitud"
                      placeholder="..."
                      @keydown.native="coordinatesKeyDown($event)"
                      v-model="device.location.longitude"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <!--spacer -->
            <b-col class="col-sm-1 col-xs-3" />
            <!--spacer -->
            <b-col>
              <b-form-group
                label-size="sm"
                label="Estado del nodo"
                label-for="status"
              >
                <b-form-select
                  size="sm"
                  id="status"
                  name="status"
                  v-model="device.status"
                  style="cursor: pointer"
                >
                  <b-form-select-option value="true"
                    >El nodo se encuentra activo</b-form-select-option
                  >
                  <b-form-select-option value="false"
                    >El nodo se encuentra inactivo</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Fila 4 -->
          <b-row>
            <b-col>
              <div
                class="innergroupBox"
                style="margin-bottom: 10px; cursor: pointer"
                v-if="showGPS"
              >
                <b-row>
                  <b-form-group
                    class="form-check form-switch"
                    style="margin-left: 50px; cursor: pointer"
                  >
                    <input
                      class="form-check-input"
                      v-model="device.location.gpsForced"
                      type="checkbox"
                      id="switchGPS"
                      style="cursor: pointer"
                    />
                    <label class="form-check-label" for="switchGPS"
                      >Forzar la posición GPS</label
                    >
                  </b-form-group>
                  <div style="padding: 0px 40px; margin-top: 0px">
                    <small
                      >Al forzar la posición GPS se toman automáticamente las
                      medidas de posicionamiento del sensor GPS del nodo.<br />
                      Solo disponible si el nodo contiene un sensor GPS.</small
                    >
                  </div>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <!-- Fila 5 -->
          <b-row>
            <b-col>
              <small>* El campo debe ser rellenado</small><br />
              <small>** Admite números negativos - Separación por coma</small>
            </b-col>
            <!--spacer -->
            <b-col class="col-sm-1 col-xs-1" />
            <!--spacer -->
            <b-col> </b-col>
          </b-row>

          <!-- Fila 6 -->
          <b-row style="margin-top: 60px">
            <b-col>
              <form-button
                label="Guardar nodo"
                customType="submit"
                v-bind:block="true"
              />
            </b-col>
            <b-col>
              <form-button
                label="Limpiar formulario"
                customType="reset"
                v-bind:block="true"
                v-if="isUserAdmin()"
              />
            </b-col>
            <b-col v-if="!device._id">
              <form-button
                label="Tipo de configuración"
                customType="return"               
                v-bind:block="true"
                @click="returnSelect"

              />
            </b-col>
            <b-col>
              <form-button
                label="Salir de la edicion"
                customType="exit"
                v-bind:block="true"
                @click="exitForm"
              />
            </b-col>
          </b-row>
        </div>
      </b-form>
      <!-- END FORMULARIO DE ADICION -->
    </div>
    <!-- END V if submitted-->
  </div>
</template>


<script>
import DeviceService from "@/services/DeviceService";
import LocationService from "@/services/LocationService";
import UserService from "@/services/UserService";

import CircleLoader from "@/components/common/CircleLoader";
import Input from "@/components/common/form/Input";
import Button from "@/components/common/form/Button";

export default {
  name: "node-edit-form",
  components: {
    "circle-loader": CircleLoader,
    "form-input": Input,
    "form-button": Button,
  },
  data() {
    return {
      device: {
        location_ref: null,
        location: {},
        status: false,
        gpsForced: false,
      },
      objectLocationList: [],
      locationList: [],
      selectedLocation: "",
      submitted: false,
      showGPS: false,
    };
  },
  mounted() {
    //Cargamos la lista
    this.selectedLocation = null;
    this.retrieveLocation();
  },
  methods: {
    
    zipCodeKeyDown(event) {
      if (
        event.key != "Backspace" &&
        event.key != "Delete" &&
        event.key != "ArrowLeft" &&
        event.key != "ArrowRight" &&
        isNaN(Number(event.key))
      ) {
        event.preventDefault();
      }
    },
    coordinatesKeyDown(event) {
      if (
        event.key != "Backspace" &&
        event.key != "Delete" &&
        event.key != "ArrowLeft" &&
        event.key != "ArrowRight" &&
        event.key != "," &&
        event.key != "." &&
        event.key != "-" &&
        isNaN(Number(event.key))
      ) {
        event.preventDefault();
      }
    },

    getDevice(idnodo) {
      //Delay de carga
      this.loadDelay();
      //Get device data
      DeviceService.get(idnodo)
        .then(async (response) => {
          this.device = response.data;
          this.selectedLocation = this.device.location_ref
            ? this.device.location_ref.alias
            : null;
          this.locationZip = this.device.location.zip;
          //Si estamos editando un nodo llamamos al servicio de GPS
          //para ver si mostramos o no el switch del GPS
          await DeviceService.getGPS(this.device._id)
            .then((response) => {
              if (response.data) {
                this.showGPS = true;
              }
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    },

    retrieveLocation() {
      LocationService.getAll()
        .then((response) => {
          this.objectLocationList = response.data;
          console.log(response.data)

          for (var i = 0; i < this.objectLocationList.length; i++) {
            var obj = this.objectLocationList[i];
            this.locationList.push(obj.alias);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    resetForm(evt) {
      evt.preventDefault();
      //Reset values from the form
      this.resetValues();
      //Mensaje de confirmacion
      this.$notify({
        group: "notificateDiv",
        type: "success",
        title: "Formulario reseteado",
        text: "Se han reestablecido los parámetros a sus valores iniciales",
        duration: 3000,
        speed: 1000,
      });
    },

    resetValues() {
      // Reset our form values
      this.device.alias = "";
      this.device.group = null;
      this.device.location_ref = null;
      this.selectedLocation = null;
      this.device.uuid = "";
      //this.device.type = "";
      this.device.status = false;
      this.device.location.zip = "";
      this.device.location.province = "";
      this.device.location.latitude = "";
      this.device.location.longitude = "";
      this.device.location.gpsForced = false;
      //Default message

      this.$refs.circleLoader.reset();
    },

    exitForm() {
      this.$emit("onClickExit");
    },
    returnSelect() {
      this.$emit("onClickReturnSelect");
    },

    loadDelay() {
      //Cargamos el div oculto
      this.submitted = true;
      this.$refs.circleLoader.showLoading("Cargando datos del nodo ...");

      //Timeout para cambiar de pagina
      setTimeout(() => {
        //Cambiamos de div
        this.submitted = false;
        if (this.$refs.circleLoader) {
          this.$refs.circleLoader.reset();
        }
      }, 500);
    },

    saveDevice(e) {
      //Prevent submit
      e.preventDefault();
      if (this.device.location.latitude) {
        this.device.location.latitude = Number(
          this.device.location.latitude.replace(",", ".")
        );
      }
      if (this.device.location.longitude) {
        this.device.location.longitude = Number(
          this.device.location.longitude.replace(",", ".")
        );
      }

      if (this.device._id) {
        this.fillLocationData(this.updateDevice);
      } else {
        this.fillLocationData(this.createDevice());
      }
    },

    fillLocationData(callback) {
      if (this.selectedLocation && this.selectedLocation != "null") {
        let selectedLocationObject = this.objectLocationList.filter((item) => {
          return item.alias == this.selectedLocation;
        });
        this.device.location_ref = selectedLocationObject[0];
        callback();
      } else {
        this.device.location_ref = null;
        callback();
      }
    },

    async updateDevice() {
      try {
        //Disable buttons before re-enabled
        this.disabledInput = true;

        // fillLocationData
        if (this.selectedLocation && this.selectedLocation != "null") {
          let responseLocation = await LocationService.findByAlias(
            this.selectedLocation
          );
          this.device.location_ref = responseLocation.data;
        } else {
          this.device.location_ref = null;
        }
        if (this.device.location.gpsForced) {
          //Llamamos al servicio getGPS
          await DeviceService.getGPS(this.device._id)
            .then((response) => {
              if (response) {
                this.device.location.latitude = response.data[0].data.latitud;
                this.device.location.longitude = response.data[0].data.longitud;
              }
            })
            .catch((e) => {
              console.log(e);
            });
        }

        // update
        let responseDevice = await DeviceService.update(this.device);

        this.getDevice(this.device._id);

        this.$notify({
          group: "notificateDiv",
          type: "success",
          title: responseDevice.data.message
            ? responseDevice.data.message
            : "Nodo modificado correctamente",
          text: responseDevice.data.message
            ? ""
            : "Se ha modificado el nodo seleccionado",
          duration: 3000,
          speed: 1000,
        });
        //delay antes de rehabilitarlos
        setTimeout(() => {
          //Avisamos al parent de que cambie componente
          this.disabledInput = false;
        }, 500);

        //Rehabilitiamso lso botones de nuevo
        this.disabledInput = false;

        //Refresh table list (parent signal)
        this.$emit("onClickSave");
      } catch (error) {
        let errorMessage = error;

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message;
        }

        this.$notify({
          group: "notificateDiv",
          type: "error",
          title: "Error al guardar los cambios",
          text: errorMessage,
          duration: 3000,
          speed: 1000,
        });

        console.log(error);
        throw new Error("Error - NodesEditForm.vue - updateDevice");
      }
    },

    async createDevice() {
      try {
        this.$refs.circleLoader.reset();
        this.$refs.circleLoader.showLoading("Registrando nodo ...");

        let data = {
          group: this.device.group,
          location_ref: this.selectedLocation ? this.selectedLocation : null,
          uuid: this.device.uuid,
          alias: this.device.alias,
          //type: "-",
          status: this.device.status ? true : false,
          location: {
            zip: this.device.location.zip,
            province: this.device.location.province,
            latitude: this.device.location.latitude,
            longitude: this.device.location.longitude,
            gpsForced: this.device.location.gpsForced,
          }
        };

        // fillLocationData
        if (this.selectedLocation) {
          let responseLocation = await LocationService.findByAlias(
            this.selectedLocation
          );
          data.location_ref = responseLocation.data;
        }
        console.log("----DATOS A INTRODUCIR---")
        console.log(data)
        let response = await DeviceService.create(data);
        console.log("--------DESPUES DE INTRODUCIR--------")
        //Mensaje de confirmacion
        this.$notify({
          group: "notificateDiv",
          type: "success",
          title: response.data.message
            ? response.data.message
            : "Nodo agregado correctamente",
          text: response.data.message
            ? ""
            : "Se ha agregado 1 nuevo nodo a la lista",
          duration: 3000,
          speed: 1000,
        });
        //Completar imagen y descargar div
        //Ocultamos el formulario
        this.submitted = true;
        //Mostramos durante 2 segundos que se está gaurdando
        setTimeout(() => {
          //Checkar cabeceras e vuelta para cargar la X o el tick
          if (!response.data.message) {
            this.$refs.circleLoader.showEndError(
              "No se ha podido registrar el nodo"
            );
          } else {
            this.$refs.circleLoader.showEndSuccess(
              "Nodo almacenado correctamente"
            );
          }
          //Temporizador antes de mostrar de nuevo el formulario
          setTimeout(() => {
            this.submitted = false;
            //Emit event to notify parent to notify the other component
            this.$emit("onClickSave");
            //Remove form data
            this.resetValues();
          }, 1500);
        }, 2500);
      } catch (error) {
        let errorMessage = error;

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message;
        }

        this.$notify({
          group: "notificateDiv",
          type: "error",
          title: "Error al guardar el nodo",
          text: errorMessage,
          duration: 3000,
          speed: 1000,
        });

        console.log(error);
        throw new Error("Error - NodesEditForm.vue - createDevice");
      }
    },

    isUserAdmin() {
      return UserService.isUserAdmin();
    },
  },
};
</script>

<style scoped>
.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 30px;
  margin-left: 30px;
  margin-right: 30px;
}
.innergroupBox {
  width: 44.3%;
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 20px;
  margin-bottom: 15px;
}
</style>